import Link from 'next/link';

export default function FooterSocialLinks() {
  return (
    <ul className='mt-8 flex justify-center gap-6 tablet:justify-start tablet:gap-8'>
      <li>
        <Link
          href='https://www.linkedin.com/company/envisionsales/'
          rel='noreferrer'
          target='_blank'
          className='text-designer-blue hover:text-white transition-colors duration-300'
        >
          <span className='sr-only'>LinkedIn</span>
          <svg
            className='size-6'
            fill='currentColor'
            viewBox='0 0 24 24'
            aria-hidden='true'
          >
            <path
              fillRule='evenodd'
              d='M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.43c-.97 0-1.75-.79-1.75-1.75s.78-1.75 1.75-1.75 1.75.79 1.75 1.75-.78 1.75-1.75 1.75zm13.5 11.43h-3v-5.37c0-1.28-.02-2.92-1.78-2.92-1.78 0-2.05 1.39-2.05 2.83v5.46h-3v-10h2.88v1.37h.04c.4-.75 1.38-1.55 2.85-1.55 3.05 0 3.62 2.01 3.62 4.62v5.56z'
              clipRule='evenodd'
            />
          </svg>
        </Link>
      </li>
      <li>
        <Link
          href='https://www.instagram.com/envisioncreates/'
          rel='noreferrer'
          target='_blank'
          className='text-designer-blue hover:text-white transition-colors duration-300'
        >
          <span className='sr-only'>Instagram</span>
          <svg
            className='size-6'
            fill='currentColor'
            viewBox='0 0 24 24'
            aria-hidden='true'
          >
            <path
              fillRule='evenodd'
              d='M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z'
              clipRule='evenodd'
            />
          </svg>
        </Link>
      </li>
      <li>
        <Link
          href='https://vimeo.com/envisioncreates'
          rel='noreferrer'
          target='_blank'
          className='text-designer-blue hover:text-white transition-colors duration-300'
        >
          <span className='sr-only'>Vimeo</span>
          <svg
            className='size-6'
            fill='currentColor'
            viewBox='0 0 24 24'
            aria-hidden='true'
          >
            <path
              fillRule='evenodd'
              d='M23.977 7.957c-.084 1.802-1.327 4.255-3.726 7.362-2.484 3.2-4.587 4.8-6.31 4.8-1.062 0-1.962-.98-2.7-2.94-.493-1.806-.98-3.613-1.474-5.418-.547-1.98-1.132-2.97-1.756-2.97-.136 0-.612.287-1.427.862L5.205 8.85c.899-.789 1.784-1.573 2.653-2.356 1.199-1.042 2.1-1.586 2.7-1.63 1.417-.127 2.29.832 2.617 2.876.356 2.253.603 3.648.74 4.183.411 1.675.864 2.507 1.361 2.507.387 0 .968-.61 1.744-1.833.775-1.222 1.186-2.153 1.23-2.792.109-1.057-.304-1.586-1.239-1.586-.44 0-.892.101-1.356.303.902-2.962 2.627-4.386 5.174-4.274 1.888.068 2.775 1.285 2.662 3.65z'
              clipRule='evenodd'
            />
          </svg>
        </Link>
      </li>
      {/* <li>
        <Link
          href='https://github.com/envisioncreates'
          rel='noreferrer'
          target='_blank'
          className='text-designer-blue hover:text-white transition-colors duration-300'
        >
          <span className='sr-only'>GitHub</span>
          <svg
            className='size-6'
            fill='currentColor'
            viewBox='0 0 24 24'
            aria-hidden='true'
          >
            <path
              fillRule='evenodd'
              d='M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z'
              clipRule='evenodd'
            />
          </svg>
        </Link>
      </li> */}
    </ul>
  );
}
